import React, { useCallback, forwardRef } from "react";
import { Input } from "antd";
import { stripHtmlBrackets } from "Utils/inputValidation";

const SbInput = forwardRef(({
  disabled = false,
  placeholder = "",
  type = "text",
  rows = 4,
  textarea = false,
  onChange,
  onValueChange,
  ...rest
}, ref) => {

  const handleChange = useCallback(
    (e) => {
      // Strip HTML angle brackets so tags like <img onerror=...> / <script>
      // can never be entered (stored-XSS prevention). Applies to all inputs.
      const value = stripHtmlBrackets(e.target.value);
      if (value !== e.target.value) {
        e.target.value = value;
      }
      const isFilled = !!value;
      onChange?.(e);
      onValueChange?.(value, isFilled);
    },
    [onChange, onValueChange]
  );

  if (textarea) {
    return (
      <Input.TextArea
        {...rest}
        ref={ref}
        rows={rows}
        disabled={disabled}
        placeholder={placeholder}
        onChange={handleChange}
      />
    );
  }

  return (
    <Input
      {...rest}
      ref={ref}
      type={type}
      disabled={disabled}
      placeholder={placeholder}
      onChange={handleChange}
    />
  );
});

export default SbInput;